module.exports = __webpack_public_path__ + "static/media/attention-image.4bc7986a.svg";